export const permissionEmail = (source, articles) => {
  const subject = `Permission request — linking to ${source} stories on Farmwatch.com`;
  const body = `Dear ${source} permissions / editorial team,

I'm writing from Farmwatch.com, an Irish agricultural news and market-data site for farmers in Ireland, the UK and further afield.

Farmwatch currently lists ${source} stories as headline, "${source}" attribution and a direct link to your page (${articles} headlines at present). No article text, standfirst or images are reproduced. We'd like to make sure this is acceptable to you, and to ask whether you would permit a short, attributed excerpt (the first paragraph or your RSS description, no more than ~300 characters) under each headline, linking to the original.

What we commit to:
- A prominent "${source}" credit and a direct, followable link to your article on every item.
- No full-text reproduction, no AI rewriting, no use of your photographs.
- Removal of any item within one working day of a request.
- A quarterly report of the click-throughs we send you, if useful.

Could you confirm (a) that headline + link is acceptable, (b) whether a short excerpt is permitted and on what terms, and (c) the best permissions contact for the future? If you have a syndication or RSS re-use policy, I'd be glad to follow it.

Kind regards,

Farmwatch.com`;
  return { subject, body, href: `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` };
};
